/**
 * Frontend helpers for multi-row merge / add-enrollment reviewer guidance.
 */

/**
 * Sibling staging docs in the current queue that share the same email.
 * @param {object[]} items
 * @param {object|null} selected
 * @returns {object[]}
 */
export function findStagingEmailSiblings(items, selected) {
  const email = String(selected?.emailKey || selected?.ruleResult?.email || '')
    .trim()
    .toLowerCase();
  if (!email || !Array.isArray(items)) return [];
  return items.filter((doc) => {
    if (!doc || doc.id === selected.id) return false;
    const other = String(doc.emailKey || doc.ruleResult?.email || '')
      .trim()
      .toLowerCase();
    return other === email;
  });
}

/**
 * @param {object|null} selected
 * @param {object[]} siblings
 */
export function resolveMultiRowGuidance(selected, siblings = []) {
  const rr = selected?.ruleResult || {};
  const fromRules = rr.multiRowGuidance;
  const siblingCount = siblings.length;
  const occurrence =
    Math.max(
      Number(rr.emailOccurrenceCount) || 0,
      Number(fromRules?.emailOccurrenceCount) || 0,
      siblingCount + 1
    ) || 1;

  if (fromRules?.show) {
    return {
      ...fromRules,
      emailOccurrenceCount: occurrence,
      siblings,
    };
  }

  // Fallback if older ruleResult lacks multiRowGuidance
  const reasons = rr.reviewReasons || [];
  const show =
    occurrence > 1 ||
    reasons.includes('duplicate_email_in_file') ||
    reasons.includes('new_enrollment_for_existing_student') ||
    rr.matchStatus === 'existing';

  if (!show) {
    return { show: false, actions: [], siblings: [], emailOccurrenceCount: occurrence };
  }

  return {
    show: true,
    emailOccurrenceCount: occurrence,
    primaryAction: fromRules?.primaryAction || null,
    recommendedEnrollment: fromRules?.recommendedEnrollment || null,
    actions: fromRules?.actions || [],
    summary:
      occurrence > 1
        ? `This email appears in ${occurrence} review rows. Merge or add enrollment on one student; every ticked row’s batch is kept, then the extra Excel rows are skipped.`
        : fromRules?.summary ||
          'Choose Merge / update profile or Add enrollment for this matched student.',
    siblings,
  };
}
